module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-hzk"
  }, [_c('el-form', {
    ref: "loginForm",
    staticClass: "layui-form layui-form-pane",
    attrs: {
      "model": _vm.loginForm,
      "rule": "rules"
    }
  }, [_c('dl', {
    staticClass: "admin_login clear-fix"
  }, [_c('dt', [_c('em', [_c('img', {
    attrs: {
      "src": "static/login/images/logo2.png",
      "alt": "合作库云数据平台"
    }
  })]), _vm._v(" "), _c('strong', [_vm._v("合作库云数据平台")])]), _vm._v(" "), _c('dd', [_c('label', {
    staticClass: "layui-form-label layui-form-label-logo"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("账号")]), _vm._v(" "), _c('div', {
    staticClass: "layui-input-inline layui-form-label-logo1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.UserName),
      expression: "loginForm.UserName"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "text",
      "placeholder": "请输入账号",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.loginForm.UserName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginForm.UserName = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('label', {
    staticClass: "layui-form-label layui-form-label-logo"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v("密码")]), _vm._v(" "), _c('div', {
    staticClass: "layui-input-inline layui-form-label-logo1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.Password),
      expression: "loginForm.Password"
    }],
    staticClass: "layui-input",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.loginForm.Password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginForm.Password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('div', [_c('button', {
    staticClass: "layui-btn layui-btn-normal",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("\n            立即提交\n          ")])])]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "fr btn-color-blur1 login-btn1",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.loginHelpDialog = true
      }
    }
  }, [_vm._v("获取账号")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "left",
      "width": "160",
      "trigger": "hover"
    }
  }, [_c('div', [_vm._v("\n            请联系客服："), _c('br'), _vm._v("0755-82405890-8931"), _c('br'), _vm._v("或者发送邮件到："), _c('br'), _vm._v("atm8123@spr-atm.com\n          ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('a', {
    staticClass: "btn-color-blur1 tips1",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("忘记密码？")])])])], 1), _vm._v(" "), _c('dd', [_c('p', {
    staticClass: "center admin_login-text"
  }, [_vm._v("© 2017 前海高扬版权所有")])])])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "温馨提示 ！",
      "size": "tiny",
      "visible": _vm.loginHelpDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.loginHelpDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "popup-login"
  }, [_c('div', {
    staticClass: "popup-content clear-fix pd-20"
  }, [_c('div', {
    staticClass: "popup-login-text"
  }, [_c('p', [_vm._v("\n            合作库只针对参与合作库业务的用户进行开放，在合作库进行托管、寄售，租赁，维修等业务的用户我们会在第一时间将账号和密码发送到您指定邮箱，通过此账号您可以在合作库上查询您一切与合作库有关的信息！\n          ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("如有疑问请您联系：")])]), _vm._v(" "), _c('p', [_vm._v("客服电话：0755-82405890-8931")]), _vm._v(" "), _c('p', [_vm._v("\n            客服邮箱："), _c('a', {
    attrs: {
      "href": "mailto:atm8123@spr-atm.com"
    }
  }, [_vm._v("atm8123@spr-atm.com")])])])])])]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeFooter"
  }, [_c('div', {
    staticClass: "footerBox"
  }, [_vm._v("\n      Copyright © 深圳前海高扬科技有限公司\n      "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn",
      "target": "blank"
    }
  }, [_vm._v("粤ICP备19007655号")]), _vm._v(" "), _c('div', {
    staticClass: "ebsBox",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "ebsBox"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "36px",
      "height": "42px",
      "display": "none"
    },
    attrs: {
      "id": "ebs2"
    }
  }, [_c('img', {
    attrs: {
      "id": "ebsgovicon",
      "src": "https://szcert.ebs.org.cn/govicons.js?id=e7c51040-bbd2-4318-850a-eb404b32e2ed&width=100&height=137&type=1",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71353275"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/LoginPage.vue
// module id = 751
// module chunks = 0